'use strict';
module.exports = require('../../full/map');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/map/index.js
// module id = 1234
// module chunks = 0